import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmGlobalOpsReportsRoute: InvariantJiraRoute = {
	name: 'products-jsm-global-ops-reports',
	path: '/jira/settings/products/ops/reports/:dashboardId',
	exact: true,
};
